import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

// Format Rupiah
const formatIDR = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
});

export default function SalesChart({ salesData }) {
    const [chartOptions, setChartOptions] = useState({});
    const [series, setSeries] = useState([]);
    const [totalSalesDeliveryData, setTotalSalesDeliveryData] = useState(0);
    const [totalSalesPickUpData, setTotalSalesPickUpData] = useState(0);

    useEffect(() => {
        if (!salesData || salesData.length === 0) return;

        const pickUpData = salesData.filter(order => order.type === "Pick Up Order");
        const deliveryData = salesData.filter(order => order.type === "Delivery Order");

        const uniqueDates = [...new Set(salesData.map(order => order.order_date))].sort();

        const groupByDate = (data) => {
            const grouped = {};
            uniqueDates.forEach(date => grouped[date] = 0);
            data.forEach(order => {
                if (grouped[order.order_date] !== undefined) {
                    grouped[order.order_date] += parseInt(order.total_payment);
                }
            });
            return Object.values(grouped);
        };

        const pickUpSeries = groupByDate(pickUpData);
        console.log(pickUpData)
        const deliverySeries = groupByDate(deliveryData);
        console.log(deliveryData)

        setChartOptions({
            chart: { type: "bar", height: 350, stacked: true },
            // colors: ['#1ABC9C', '#F2711C'],
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return global.IDR.format(val);
                    },
                },
            },
            xaxis: {
                categories: uniqueDates.map(date =>
                    new Date(date).toLocaleDateString('in-US', {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric'
                    })
                )
            },
            plotOptions: { bar: { horizontal: false } },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 1, colors: ["transparent"] },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return global.IDR.format(val);
                    },
                },
            },
            legend: { position: "top" },
        });


        setSeries([
            { name: "Delivery", data: deliverySeries },
            { name: "Pick Up", data: pickUpSeries },
        ]);

        const totalPickUp = pickUpData.reduce((acc, item) => acc + parseInt(item.total_payment), 0);
        const totalDelivery = deliveryData.reduce((acc, item) => acc + parseInt(item.total_payment), 0);

        setTotalSalesPickUpData(totalPickUp);
        setTotalSalesDeliveryData(totalDelivery);
    }, [salesData]);

    return (
        <div>
        <ReactApexChart options={chartOptions} series={series} type="bar" height={350} />
            <div className="d-flex justify-content-evenly">
                <p>Total Delivery Sales: <strong>{global.IDR.format(totalSalesDeliveryData)}</strong></p>
                <p>Total Pick Up Sales: <strong>{global.IDR.format(totalSalesPickUpData)}</strong></p>
            </div>
        </div>
  );
}
